import React from 'react';
const links = [{
  label: 'Conditions',
  href: '#terms'
}, {
  label: 'Confidentialité',
  href: '#privacy'
}, {
  label: 'Remboursements',
  href: '#refund'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-160" data-mp="35czq9qe59dmy">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-161" data-mp="3a6vjkfjgqcbs">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-162" data-mp="3k36xf9ypba8c">
          Nail Educator Ready™
        </p>
        <nav aria-label="Pied de page" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-163" data-mp="3o63lvhaxa0k7">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-164" data-mp="3t1ixe2lgjkdg">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-165" data-mp="ojzpl71okpk">
        © 2026 Nail Educator Ready™ — Édition Française. Ressource pédagogique numérique pour formatrices
        ongulaires. Ne constitue pas une certification, un diplôme ou une accréditation officielle.
        Paiement sécurisé — traité dans votre devise locale.
      </p>
    </footer>;
}